function productAltImages(container) {
  // Product image ALT function
  var $ProductContainer = container ? $(container) : $('.product-container-wrapper');
  var mediaFilter = $ProductContainer.data('media-filter');
  var $featuredmediaGroup = $ProductContainer.find('[data-product-single-media-group]');
  var $thumbmediaGroup = $ProductContainer.find('[data-product-thumbs]');
  var sectionId = $ProductContainer.attr('data-section-id');
  var productId = $ProductContainer.attr('data-product-id');

  if (mediaFilter) {
    var productJson = JSON.parse(document.getElementById('ProductJson-' + sectionId + '-' + productId).innerHTML);
    var mediaObj = productJson.media;

    $ProductContainer.find('.variant-input-wrap[data-handle="color"] .variant-input').each(function () {
      if ($(this).find('input').is(":checked")) {
        var color_name = $(this).find('input').attr('data-color-name');
        thumbMediaUpdate(mediaObj, color_name, $ProductContainer);
        mainMediaUpdate(mediaObj, color_name, $ProductContainer);
        document.dispatchEvent(new CustomEvent('color-images:update'))
      }
    })

    $ProductContainer.find('.variant-input-wrap[data-handle="color"] .variant-input input').change(function () {
      if (productJson.media.length > 0) {
        var color_name = $(this).attr('data-color-name');
        thumbMediaUpdate(mediaObj, color_name, $ProductContainer);
        mainMediaUpdate(mediaObj, color_name, $ProductContainer);
        document.dispatchEvent(new CustomEvent('color-images:update'))
      }
    });
  }
}

$(document).on('quickview:loaded', function (event) {
  productAltImages(event.detail.container)
})

$(document).ready(function () {

  productAltImages()

  // Product page - buy now button
  $(document).on('click', '.js-buy_now_btn', function (e) {
    e.preventDefault();
    var variant_id = $('.product-single__meta .product-single__variants option:selected').val();
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      async: false,
      data: {
        quantity: 1,
        id: variant_id
      },
      dataType: 'json',
      error: function (data) {
        console.log('product unavailable');
      },
      success: function (data) {
        window.location.href = "/checkout";
      },
      cache: false
    });
  });

  // Product page - sticky add to cart button for mobile
  if (!theme.config.bpSmall) {
    $(window).scroll(function () {

    });
  }

  // Collection Infinite Scroll
  if (window.theme.settings.paginationType == 'infinite_scroll') {
    if ($('.collection-grid__wrapper .grid').hasClass('js-infinite-wrapper')) {
      enableInfiniteScroll('.js-infinite-wrapper');
      $('[data-load-more]').addClass('is-hidden');
    }
  }
  if (window.theme.settings.paginationType == 'load_more_button') {
    enableLoadMoreButton('.js-infinite-wrapper');
  }

  // Collection hover video play
  $('.js-collection_has_video').hover(
    function () {
      $(this).find('.collection-hover__video').trigger('play');
    }, function () {
      $(this).find('.collection-hover__video').trigger('pause');
    }
  );

  // Collection vertical video play
  $('.product-video-item .video-pause').click(function () {
    $(this).addClass('hide');
    $(this).prev().addClass('active');
    $(this).closest('.product-video-item').find('.collection-vertical__video').trigger('pause');
  });
  $('.product-video-item .video-play').click(function () {
    $(this).removeClass('active');
    $(this).next().removeClass('hide');
    $(this).prev().trigger('play');
  });
  $('.collection-vertical__video').click(function () {
    if (this.paused) {
      $(this).next().removeClass('active');
      $(this).closest('.product-video-item').find('.video-pause').removeClass('hide');
      $(this).closest('.product-video-item').find('.video-pause').addClass('is_active');
    } else {
      $(this).closest('.product-video-item').find('.video-pause').addClass('hide');
      $(this).next().addClass('active');
    }
  });
  $('.product-video-item').hover(function () {
    $(this).find('.video-pause').addClass('is_active');
  }, function () {
    $(this).find('.video-pause').removeClass('is_active');
  });

  // Disable collection color swatch link
  $('.grid-product__colors .color-swatch--with-image').click(function (e1) {
    e1.preventDefault();
  });

  // Collection filter
  if (!theme.config.bpSmall) {
    // desktop
    $(document).on('click', '.js-open-col-filters', function () {
      if ($(this).hasClass('is-open')) {
        $(this).closest('#CollectionAjaxContent').find('.grid__item--sidebar').addClass('hide');
        $(this).closest('#CollectionAjaxContent').find('.grid__item--content').removeClass('medium-up--three-quarters');
        $(this).closest('#CollectionAjaxContent').find('.grid-product').addClass('medium-up--one-quarter');
        $(this).closest('#CollectionAjaxContent').find('.grid-product').removeClass('medium-up--one-third');
        $(this).removeClass('is-open');
      } else {
        $(this).closest('#CollectionAjaxContent').find('.grid__item--sidebar').removeClass('hide');
        $(this).closest('#CollectionAjaxContent').find('.grid__item--content').addClass('medium-up--three-quarters');
        $(this).closest('#CollectionAjaxContent').find('.grid-product').removeClass('medium-up--one-quarter');
        $(this).closest('#CollectionAjaxContent').find('.grid-product').addClass('medium-up--one-third');
        $(this).addClass('is-open');
      }
    });
  } else {
    // mobile
    $(document).on('click', '.js-open-col-filters', function (e) {
      e.preventDefault();
      e.stopPropagation();
      $(this).closest('#CollectionAjaxContent').find('.grid__item--sidebar').removeClass('hide');
      theme.FilterDrawer.open();
    });
  }

  // Collection sorting filter — custom dropdown only (hide native duplicate)
  $(document).on('click', '.col-sorting .ymi-sort__trigger, .col-sorting .select__trigger', function (e) {
    e.preventDefault();
    e.stopPropagation();
    var $select = $(this).closest('.select');
    var isOpen = $select.hasClass('open');
    $('.col-sorting .select').removeClass('open');
    $('.col-sorting .ymi-sort__trigger').attr('aria-expanded', 'false');
    $('.col-sorting .ymi-sort__menu').attr('hidden', true);
    if (!isOpen) {
      $select.addClass('open');
      $(this).attr('aria-expanded', 'true');
      $select.find('.ymi-sort__menu, .custom-options').removeAttr('hidden');
    }
  });
  $(document).on('click', '.col-sorting .custom-option', function (e) {
    e.preventDefault();
    e.stopPropagation();

    var $option = $(this);
    var selectDataVal = $option.attr('data-value');
    var selectedLabel = $.trim($option.text());
    if (!selectDataVal) return;

    $('.col-sorting .custom-option').removeClass('selected').attr('aria-selected', 'false');
    $('.col-sorting .custom-option[data-value="' + selectDataVal + '"]').addClass('selected').attr('aria-selected', 'true');
    $('.col-sorting [data-sort-label]').text(selectedLabel);
    $('.col-sorting .select').removeClass('open');
    $('.col-sorting .ymi-sort__trigger').attr('aria-expanded', 'false');
    $('.col-sorting .ymi-sort__menu').attr('hidden', true);

    // Keep all native selects in sync (desktop + drawer)
    $('select[name="SortBy"]').val(selectDataVal);

    // Sort within this collection only (preserve path + existing filters)
    try {
      var params = new URLSearchParams(window.location.search);
      params.set('sort_by', selectDataVal);
      params.delete('page');
      var qs = params.toString();
      window.location.assign(window.location.pathname + (qs ? '?' + qs : '') + window.location.hash);
    } catch (err) {
      var sortSelect = document.querySelector('select[name="SortBy"]');
      if (sortSelect) {
        sortSelect.value = selectDataVal;
        sortSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  });
  window.addEventListener('click', function (e) {
    document.querySelectorAll('.col-sorting .select.open').forEach(function (select) {
      if (!select.contains(e.target)) {
        select.classList.remove('open');
        var trigger = select.querySelector('.ymi-sort__trigger');
        var menu = select.querySelector('.ymi-sort__menu, .custom-options');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        if (menu) menu.setAttribute('hidden', true);
      }
    });
  });

  $(document).on('keydown', '.col-sorting .ymi-sort__trigger, .col-sorting .custom-option', function (e) {
    var key = e.key;
    var $control = $(this).closest('.select');
    var $trigger = $control.find('.ymi-sort__trigger').first();
    var $menu = $control.find('.ymi-sort__menu, .custom-options').first();
    var $options = $menu.find('.custom-option');
    if (!$options.length) return;

    if (key === 'Escape') {
      $control.removeClass('open');
      $trigger.attr('aria-expanded', 'false');
      $menu.attr('hidden', true);
      $trigger.trigger('focus');
      return;
    }

    if (key === 'ArrowDown' || key === 'ArrowUp' || key === 'Home' || key === 'End') {
      e.preventDefault();
      if ($menu.attr('hidden')) {
        $control.addClass('open');
        $trigger.attr('aria-expanded', 'true');
        $menu.removeAttr('hidden');
      }
      var index = $options.index(document.activeElement);
      if (key === 'ArrowDown') index = index < 0 ? 0 : Math.min($options.length - 1, index + 1);
      if (key === 'ArrowUp') index = index < 0 ? $options.length - 1 : Math.max(0, index - 1);
      if (key === 'Home') index = 0;
      if (key === 'End') index = $options.length - 1;
      $options.eq(index).trigger('focus');
    }
  });

  // Client-side Most Reviewed reorder (when native Shopify sort is unavailable)
  function ymiSortMostReviewed() {
    try {
      var params = new URLSearchParams(window.location.search);
      var sortBy = params.get('sort_by') || '';
      if (sortBy !== 'most-reviewed' && sortBy.indexOf('review') === -1) return;

      var grid = document.querySelector('.js-infinite-wrapper[data-load-more--grid]') ||
        document.querySelector('.collection-grid__wrapper .js-infinite-wrapper');
      if (!grid) return;

      var items = Array.prototype.slice.call(grid.querySelectorAll('.grid-product[data-load-more--grid-item], .grid-product'));
      if (items.length < 2) return;

      items.sort(function (a, b) {
        var ca = parseInt(a.getAttribute('data-review-count') || '0', 10) || 0;
        var cb = parseInt(b.getAttribute('data-review-count') || '0', 10) || 0;
        return cb - ca;
      });

      var loadMore = grid.querySelector('.js-load-more');
      var loadMoreIcon = grid.parentNode && grid.parentNode.querySelector('.load-more__icon');
      items.forEach(function (el) { grid.appendChild(el); });
      if (loadMore) grid.appendChild(loadMore);
      if (loadMoreIcon && loadMoreIcon.parentNode === grid) grid.appendChild(loadMoreIcon);
    } catch (err) { /* ignore */ }
  }
  ymiSortMostReviewed();
  document.addEventListener('collection:reloaded', ymiSortMostReviewed);
  document.addEventListener('collection:page-loaded', ymiSortMostReviewed);

  // Featured category filter
  $('.js-featured-filter').on('click', function () {
    var filterType = $(this).attr('data-filter-type');
    var filterValue = $(this).attr('data-filter-value');
    var collectionSidebar = $('#CollectionSidebar');
    const filtersForm = document.querySelectorAll('.filter-form');
    filtersForm.forEach(form => {
      const filters = form.querySelectorAll('.tag-list .tag');
      const inputs = form.querySelectorAll('input');
      filters.forEach((filter, index) => {
        inputs[index] && inputs[index].removeAttribute('checked');
        filter.classList.remove('tag--active');
      })
      form.submit();
    })


    $(this).toggleClass('filter-active');

    var selectedInput = collectionSidebar.find(`[name="${filterType}"][value="${filterValue}"]`);
    selectedInput.click();

    filtersForm.forEach(form => {
      form.submit()
    })
  });

  // Collection color more button
  $('.js-color-more-btn').on('click', function () {
    $(this).hide();
    $(this).closest('.grid-product__colors').find('a').removeClass('hide');
  });

  // Header menu underline
  $('.active-header .site-nav .site-nav__item').each(function () {
    $(this).find('.site-nav__dropdown li').each(function () {
      if ($(this).find('.site-nav__dropdown-link').hasClass('grandchild-link_underline')) {
        $(this).closest('.site-nav__item').find('.site-nav__link.site-nav__link--underline').addClass('is-show');
        return false;
      }
    });
  });
  $('.active-header .site-nav .site-nav__item').each(function () {
    $(this).find('.site-nav__dropdown .grid__item').each(function () {
      $(this).find('.grandchildlink-part').each(function () {
        if ($(this).find('.site-nav__dropdown-link').hasClass('grandchild-link_underline')) {
          $(this).closest('.site-nav__item').find('.site-nav__link.site-nav__link--underline').addClass('is-show');
          return false;
        }
      });
    });
  });

  // Header submenu hover underline
  $('.site-nav__dropdown .js-nav-second-level').hover(
    function () {
      $(this).addClass('is-underline');
    }, function () {
      $(this).removeClass('is-underline');
    }
  );

  // Header toolbar sticky
  $(window).scroll(function () {
    // Skip this handler on mobile devices to prevent conflicts
    if (window.matchMedia('(max-width: 768px)').matches) {
      return;
    }

    var topbar_height = $('.active-header .js-sticky_topbar').outerHeight();
    var toolbar_height = $('.active-header .js-toolbar_sticky .toolbar').outerHeight();

    if (topbar_height == undefined) {
      topbar_height = 0;
    }
    if (toolbar_height == undefined) {
      toolbar_height = 0;
    }

    var sticky_height = topbar_height + toolbar_height;

    if (sticky_height != 0) {
      sticky_height = sticky_height - 1;
    }

    var height = $(window).scrollTop();

    if (height > 250) {
      $('.js-sticky_topbar').addClass('site-header--sticky');
      setTimeout(function () {
        $('.js-sticky_topbar').addClass('site-header--sticky--opening');
      }, 200);

      $(".active-header .js-toolbar_sticky .menu-container").addClass('site-header--sticky');
      setTimeout(function () {
        $(".active-header .js-toolbar_sticky .menu-container").addClass('site-header--sticky--opening');
        $('.active-header .js-toolbar_sticky .menu-container').css('top', topbar_height);
        $('.product-single__sticky').css('top', $('.active-header .js-toolbar_sticky .menu-container').outerHeight() + 20)
      }, 250);

      $('.active-header .header-sticky-wrapper #SiteHeader').css('top', topbar_height);
    } else {
      $('.js-sticky_topbar').removeClass('site-header--sticky');
      setTimeout(function () {
        $('.js-sticky_topbar').removeClass('site-header--sticky--opening');
      }, 200);
      $(".active-header .js-toolbar_sticky .menu-container").removeClass('site-header--sticky');
      $('.product-single__sticky').css('top', '')
      setTimeout(function () {
        $(".active-header .js-toolbar_sticky .menu-container").removeClass('site-header--sticky--opening');
        $('.active-header .js-toolbar_sticky .menu-container').css('top', '0px');
      }, 250);

      $('.active-header .header-sticky-wrapper #SiteHeader').css('top', '0px');
    }
  });

  // Header camera hover trigger
  $(document).on('click', '.js-camera-trigger', function () {
    $('.header-camera-button').trigger('click');
  });
});

$(document).ready(function () {
  function isMobile() {
    return window.matchMedia('(max-width: 768px)').matches;
  }

  function updateMobileStickyStack() {
    if (!isMobile()) return;

    var mobileHeader = document.querySelector('.active-header [data-section-type="header"]');
    if (!mobileHeader) return;

    // Prefer visible header stack height so we don't leave a white gap above the looping promo.
    var height = Math.round(mobileHeader.getBoundingClientRect().height) || mobileHeader.offsetHeight || 0;
    if (height < 1) {
      var siteHeader = document.querySelector('.active-header #SiteHeader, .active-header .site-header');
      var promo = document.querySelector('.active-header .js-promo-sliders, .active-header .announcement-bar');
      height = (siteHeader ? siteHeader.offsetHeight : 0) + (promo ? promo.offsetHeight : 0);
    }

    document.documentElement.style.setProperty(
      '--mobile-sticky-stack',
      height + 'px'
    );

    // Keep countdown top bar height in sync so header sits below it on mobile
    var topbar = document.querySelector('#shopify-section-top-bar > section, .top-bar-section > section');
    var topbarHeight = topbar ? Math.round(topbar.getBoundingClientRect().height) : 0;
    if (topbarHeight < 1 && topbar) {
      topbarHeight = topbar.offsetHeight || 0;
    }
    document.documentElement.style.setProperty(
      '--ymi-topbar-height',
      (topbarHeight > 0 ? topbarHeight : 0) + 'px'
    );

    document.dispatchEvent(new Event('mobile-header:sticky-change'));
  }

  function cleanupMobileStickyClasses() {
    $('.active-header').removeClass('active-header--sticky');
    $('.active-header #HeaderWrapper').removeClass('header-wrapper--mobile-sticky');
    $('.active-header .js-toolbar_sticky').removeClass('header-mobile-pinned');
    $('.active-header .site-header--heading-style').css('top', '');
  }

  function handleScroll() {
    var activeHeader = $('.active-header');
    var topbar = $('.js-sticky_topbar.site-header--sticky');
    var toolbar = $('.active-header .toolbar');
    var headerWrapper = $('.active-header #HeaderWrapper');

    if (isMobile()) {
      updateMobileStickyStack();
      return;
    }

    var offset = 0;
    if (topbar.length) {
      offset = topbar.outerHeight();
    }
    if (toolbar.length) {
      offset -= toolbar.outerHeight();
    }

    activeHeader.css('--default-offset', -activeHeader.outerHeight() + 'px');
    activeHeader.css('--sticky-offset', offset + 'px');
    activeHeader.removeClass('active-header--sticky');
    headerWrapper.removeClass('header-wrapper--mobile-sticky');
  }

  $(window).on('scroll', handleScroll);
  $(window).on('resize', updateMobileStickyStack);
  $(window).on('load', updateMobileStickyStack);
  $(document).on('header:toggle', function () {
    setTimeout(updateMobileStickyStack, 100);
  });

  handleScroll();
  cleanupMobileStickyClasses();
  updateMobileStickyStack();
});

/* Redo chat: mobile hide prompt text; lighter icon, darker on hover */
(function () {
  var STYLE_ID = 'ymi-redo-mobile-icon-only';
  var CSS_TEXT = [
    '@media (max-width: 768px) {',
    '  [data-target="supp-chat-bubble-text"],',
    '  .supp-chat-bubble-text {',
    '    display: none !important;',
    '    width: 0 !important;',
    '    height: 0 !important;',
    '    overflow: hidden !important;',
    '    margin: 0 !important;',
    '    padding: 0 !important;',
    '    font-size: 0 !important;',
    '    opacity: 0 !important;',
    '    pointer-events: none !important;',
    '  }',
    '  #chat-widget-button,',
    '  [aria-label="Open chat widget"] {',
    '    gap: 0 !important;',
    '    column-gap: 0 !important;',
    '    row-gap: 0 !important;',
    '  }',
    '  #chat-widget-button svg,',
    '  [aria-label="Open chat widget"] svg {',
    '    opacity: 0.55 !important;',
    '    filter: brightness(1.35) !important;',
    '    transition: opacity 0.2s ease, filter 0.2s ease !important;',
    '  }',
    '  #chat-widget-button:hover svg,',
    '  #chat-widget-button:focus svg,',
    '  [aria-label="Open chat widget"]:hover svg,',
    '  [aria-label="Open chat widget"]:focus svg {',
    '    opacity: 1 !important;',
    '    filter: brightness(0.65) !important;',
    '  }',
    '}'
  ].join('\n');

  function getShadowRoots() {
    var roots = [];
    var host = document.getElementById('redo-chat-widget');
    if (host && host.shadowRoot) roots.push(host.shadowRoot);

    var btn = document.getElementById('chat-widget-button');
    if (btn) {
      var root = btn.getRootNode && btn.getRootNode();
      if (root && root.nodeType === 11 && roots.indexOf(root) === -1) {
        roots.push(root);
      }
    }
    return roots;
  }

  function hidePromptText(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('[data-target="supp-chat-bubble-text"], .supp-chat-bubble-text').forEach(function (el) {
      el.style.setProperty('display', 'none', 'important');
      el.setAttribute('aria-hidden', 'true');
    });
    root.querySelectorAll('#chat-widget-button, [aria-label="Open chat widget"]').forEach(function (btn) {
      btn.style.setProperty('gap', '0', 'important');
      btn.style.setProperty('column-gap', '0', 'important');
      btn.style.setProperty('row-gap', '0', 'important');
    });
  }

  function injectStyles(root) {
    if (!root) return;
    var style = root.getElementById(STYLE_ID);
    if (!style) {
      style = document.createElement('style');
      style.id = STYLE_ID;
      root.appendChild(style);
    }
    style.textContent = CSS_TEXT;
    hidePromptText(root);
  }

  function applyAll() {
    var roots = getShadowRoots();
    if (!roots.length) return false;
    roots.forEach(injectStyles);
    return true;
  }

  applyAll();

  var observer = new MutationObserver(function () {
    applyAll();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  var tries = 0;
  var timer = setInterval(function () {
    applyAll();
    tries += 1;
    if (tries > 40) clearInterval(timer);
  }, 500);
})();

function thumbMediaUpdate(mediaObj, color_name, container) {
  var allImagesAltIsBlank = true
  $.each(mediaObj, function (i, val) {
    var mediaAlt = val.alt;
    var mediaImageID = val.id;
    if (mediaAlt != null) {
      allImagesAltIsBlank = false
    }
  });
  if (allImagesAltIsBlank) {
    $(container).attr('data-media-filter', 'false')
  } else {
    $(container).find('.product__thumb-item').removeClass('is-actived');
    $.each(mediaObj, function (i, val) {
      var mediaAlt = val.alt;
      var mediaImageID = val.id;
      if (mediaAlt != null) {
        if (mediaAlt === color_name) {
          $(container).find('.product__thumb[data-id="' + mediaImageID + '"]').closest('.product__thumb-item').addClass('is-actived');
        }
      }
    });
  }
}

function mainMediaUpdate(mediaObj, color_name, container) {
  var allImagesAltIsBlank = true
  $.each(mediaObj, function (i, val) {
    var mediaAlt = val.alt;
    var mediaImageID = val.id;
    if (mediaAlt != null) {
      allImagesAltIsBlank = false
    }
  });
  if (allImagesAltIsBlank) {
    $(container).attr('data-media-filter', 'false')
  } else {
    $(container).find('.product-main-slide').removeClass('is-actived');
    $.each(mediaObj, function (i, val) {
      var mediaAlt = val.alt;
      var mediaImageID = val.id;
      if (mediaAlt != null) {
        if (mediaAlt === color_name) {
          $(container).find('.product-main-slide[data-id="' + mediaImageID + '"]').addClass('is-actived');
        }
      }
    });
  }
}

/* ===============================================
  #Waypoints
================================================== */
/*!
Waypoints - 4.0.0
Copyright © 2011-2015 Caleb Troughton
Licensed under the MIT license.
https://github.com/imakewebthings/waypoints/blob/master/licenses.txt
*/
!function () { "use strict"; function t(o) { if (!o) throw new Error("No options passed to Waypoint constructor"); if (!o.element) throw new Error("No element option passed to Waypoint constructor"); if (!o.handler) throw new Error("No handler option passed to Waypoint constructor"); this.key = "waypoint-" + e, this.options = t.Adapter.extend({}, t.defaults, o), this.element = this.options.element, this.adapter = new t.Adapter(this.element), this.callback = o.handler, this.axis = this.options.horizontal ? "horizontal" : "vertical", this.enabled = this.options.enabled, this.triggerPoint = null, this.group = t.Group.findOrCreate({ name: this.options.group, axis: this.axis }), this.context = t.Context.findOrCreateByElement(this.options.context), t.offsetAliases[this.options.offset] && (this.options.offset = t.offsetAliases[this.options.offset]), this.group.add(this), this.context.add(this), i[this.key] = this, e += 1 } var e = 0, i = {}; t.prototype.queueTrigger = function (t) { this.group.queueTrigger(this, t) }, t.prototype.trigger = function (t) { this.enabled && this.callback && this.callback.apply(this, t) }, t.prototype.destroy = function () { this.context.remove(this), this.group.remove(this), delete i[this.key] }, t.prototype.disable = function () { return this.enabled = !1, this }, t.prototype.enable = function () { return this.context.refresh(), this.enabled = !0, this }, t.prototype.next = function () { return this.group.next(this) }, t.prototype.previous = function () { return this.group.previous(this) }, t.invokeAll = function (t) { var e = []; for (var o in i) e.push(i[o]); for (var n = 0, r = e.length; r > n; n++)e[n][t]() }, t.destroyAll = function () { t.invokeAll("destroy") }, t.disableAll = function () { t.invokeAll("disable") }, t.enableAll = function () { t.invokeAll("enable") }, t.refreshAll = function () { t.Context.refreshAll() }, t.viewportHeight = function () { return window.innerHeight || document.documentElement.clientHeight }, t.viewportWidth = function () { return document.documentElement.clientWidth }, t.adapters = [], t.defaults = { context: window, continuous: !0, enabled: !0, group: "default", horizontal: !1, offset: 0 }, t.offsetAliases = { "bottom-in-view": function () { return this.context.innerHeight() - this.adapter.outerHeight() }, "right-in-view": function () { return this.context.innerWidth() - this.adapter.outerWidth() } }, window.Waypoint = t }(), function () { "use strict"; function t(t) { window.setTimeout(t, 1e3 / 60) } function e(t) { this.element = t, this.Adapter = n.Adapter, this.adapter = new this.Adapter(t), this.key = "waypoint-context-" + i, this.didScroll = !1, this.didResize = !1, this.oldScroll = { x: this.adapter.scrollLeft(), y: this.adapter.scrollTop() }, this.waypoints = { vertical: {}, horizontal: {} }, t.waypointContextKey = this.key, o[t.waypointContextKey] = this, i += 1, this.createThrottledScrollHandler(), this.createThrottledResizeHandler() } var i = 0, o = {}, n = window.Waypoint, r = window.onload; e.prototype.add = function (t) { var e = t.options.horizontal ? "horizontal" : "vertical"; this.waypoints[e][t.key] = t, this.refresh() }, e.prototype.checkEmpty = function () { var t = this.Adapter.isEmptyObject(this.waypoints.horizontal), e = this.Adapter.isEmptyObject(this.waypoints.vertical); t && e && (this.adapter.off(".waypoints"), delete o[this.key]) }, e.prototype.createThrottledResizeHandler = function () { function t() { e.handleResize(), e.didResize = !1 } var e = this; this.adapter.on("resize.waypoints", function () { e.didResize || (e.didResize = !0, n.requestAnimationFrame(t)) }) }, e.prototype.createThrottledScrollHandler = function () { function t() { e.handleScroll(), e.didScroll = !1 } var e = this; this.adapter.on("scroll.waypoints", function () { (!e.didScroll || n.isTouch) && (e.didScroll = !0, n.requestAnimationFrame(t)) }) }, e.prototype.handleResize = function () { n.Context.refreshAll() }, e.prototype.handleScroll = function () { var t = {}, e = { horizontal: { newScroll: this.adapter.scrollLeft(), oldScroll: this.oldScroll.x, forward: "right", backward: "left" }, vertical: { newScroll: this.adapter.scrollTop(), oldScroll: this.oldScroll.y, forward: "down", backward: "up" } }; for (var i in e) { var o = e[i], n = o.newScroll > o.oldScroll, r = n ? o.forward : o.backward; for (var s in this.waypoints[i]) { var a = this.waypoints[i][s], l = o.oldScroll < a.triggerPoint, h = o.newScroll >= a.triggerPoint, p = l && h, u = !l && !h; (p || u) && (a.queueTrigger(r), t[a.group.id] = a.group) } } for (var c in t) t[c].flushTriggers(); this.oldScroll = { x: e.horizontal.newScroll, y: e.vertical.newScroll } }, e.prototype.innerHeight = function () { return this.element == this.element.window ? n.viewportHeight() : this.adapter.innerHeight() }, e.prototype.remove = function (t) { delete this.waypoints[t.axis][t.key], this.checkEmpty() }, e.prototype.innerWidth = function () { return this.element == this.element.window ? n.viewportWidth() : this.adapter.innerWidth() }, e.prototype.destroy = function () { var t = []; for (var e in this.waypoints) for (var i in this.waypoints[e]) t.push(this.waypoints[e][i]); for (var o = 0, n = t.length; n > o; o++)t[o].destroy() }, e.prototype.refresh = function () { var t, e = this.element == this.element.window, i = e ? void 0 : this.adapter.offset(), o = {}; this.handleScroll(), t = { horizontal: { contextOffset: e ? 0 : i.left, contextScroll: e ? 0 : this.oldScroll.x, contextDimension: this.innerWidth(), oldScroll: this.oldScroll.x, forward: "right", backward: "left", offsetProp: "left" }, vertical: { contextOffset: e ? 0 : i.top, contextScroll: e ? 0 : this.oldScroll.y, contextDimension: this.innerHeight(), oldScroll: this.oldScroll.y, forward: "down", backward: "up", offsetProp: "top" } }; for (var r in t) { var s = t[r]; for (var a in this.waypoints[r]) { var l, h, p, u, c, d = this.waypoints[r][a], f = d.options.offset, w = d.triggerPoint, y = 0, g = null == w; d.element !== d.element.window && (y = d.adapter.offset()[s.offsetProp]), "function" == typeof f ? f = f.apply(d) : "string" == typeof f && (f = parseFloat(f), d.options.offset.indexOf("%") > -1 && (f = Math.ceil(s.contextDimension * f / 100))), l = s.contextScroll - s.contextOffset, d.triggerPoint = y + l - f, h = w < s.oldScroll, p = d.triggerPoint >= s.oldScroll, u = h && p, c = !h && !p, !g && u ? (d.queueTrigger(s.backward), o[d.group.id] = d.group) : !g && c ? (d.queueTrigger(s.forward), o[d.group.id] = d.group) : g && s.oldScroll >= d.triggerPoint && (d.queueTrigger(s.forward), o[d.group.id] = d.group) } } return n.requestAnimationFrame(function () { for (var t in o) o[t].flushTriggers() }), this }, e.findOrCreateByElement = function (t) { return e.findByElement(t) || new e(t) }, e.refreshAll = function () { for (var t in o) o[t].refresh() }, e.findByElement = function (t) { return o[t.waypointContextKey] }, window.onload = function () { r && r(), e.refreshAll() }, n.requestAnimationFrame = function (e) { var i = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || t; i.call(window, e) }, n.Context = e }(), function () { "use strict"; function t(t, e) { return t.triggerPoint - e.triggerPoint } function e(t, e) { return e.triggerPoint - t.triggerPoint } function i(t) { this.name = t.name, this.axis = t.axis, this.id = this.name + "-" + this.axis, this.waypoints = [], this.clearTriggerQueues(), o[this.axis][this.name] = this } var o = { vertical: {}, horizontal: {} }, n = window.Waypoint; i.prototype.add = function (t) { this.waypoints.push(t) }, i.prototype.clearTriggerQueues = function () { this.triggerQueues = { up: [], down: [], left: [], right: [] } }, i.prototype.flushTriggers = function () { for (var i in this.triggerQueues) { var o = this.triggerQueues[i], n = "up" === i || "left" === i; o.sort(n ? e : t); for (var r = 0, s = o.length; s > r; r += 1) { var a = o[r]; (a.options.continuous || r === o.length - 1) && a.trigger([i]) } } this.clearTriggerQueues() }, i.prototype.next = function (e) { this.waypoints.sort(t); var i = n.Adapter.inArray(e, this.waypoints), o = i === this.waypoints.length - 1; return o ? null : this.waypoints[i + 1] }, i.prototype.previous = function (e) { this.waypoints.sort(t); var i = n.Adapter.inArray(e, this.waypoints); return i ? this.waypoints[i - 1] : null }, i.prototype.queueTrigger = function (t, e) { this.triggerQueues[e].push(t) }, i.prototype.remove = function (t) { var e = n.Adapter.inArray(t, this.waypoints); e > -1 && this.waypoints.splice(e, 1) }, i.prototype.first = function () { return this.waypoints[0] }, i.prototype.last = function () { return this.waypoints[this.waypoints.length - 1] }, i.findOrCreate = function (t) { return o[t.axis][t.name] || new i(t) }, n.Group = i }(), function () { "use strict"; function t(t) { this.$element = e(t) } var e = window.jQuery, i = window.Waypoint; e.each(["innerHeight", "innerWidth", "off", "offset", "on", "outerHeight", "outerWidth", "scrollLeft", "scrollTop"], function (e, i) { t.prototype[i] = function () { var t = Array.prototype.slice.call(arguments); return this.$element[i].apply(this.$element, t) } }), e.each(["extend", "inArray", "isEmptyObject"], function (i, o) { t[o] = e[o] }), i.adapters.push({ name: "jquery", Adapter: t }), i.Adapter = t }(), function () { "use strict"; function t(t) { return function () { var i = [], o = arguments[0]; return t.isFunction(arguments[0]) && (o = t.extend({}, arguments[1]), o.handler = arguments[0]), this.each(function () { var n = t.extend({}, o, { element: this }); "string" == typeof n.context && (n.context = t(this).closest(n.context)[0]), i.push(new e(n)) }), i } } var e = window.Waypoint; window.jQuery && (window.jQuery.fn.waypoint = t(window.jQuery)), window.Zepto && (window.Zepto.fn.waypoint = t(window.Zepto)) }();

/*!
Waypoints Infinite Scroll Shortcut - 4.0.0
Copyright © 2011-2015 Caleb Troughton
Licensed under the MIT license.
https://github.com/imakewebthings/waypoints/blob/master/licenses.txt
*/
!function () { "use strict"; function t(n) { this.options = i.extend({}, t.defaults, n), this.container = this.options.element, "auto" !== this.options.container && (this.container = this.options.container), this.$container = i(this.container), this.$more = i(this.options.more), this.$more.length && (this.setupHandler(), this.waypoint = new o(this.options)) } var i = window.jQuery, o = window.Waypoint; t.prototype.setupHandler = function () { this.options.handler = i.proxy(function () { this.options.onBeforePageLoad(), this.destroy(), this.$container.addClass(this.options.loadingClass), i.get(i(this.options.more).attr("href"), i.proxy(function (t) { var n = i(i.parseHTML(t)), e = n.find(this.options.more), s = n.find(this.options.items); s.length || (s = n.filter(this.options.items)), this.$container.append(s), this.$container.removeClass(this.options.loadingClass), e.length || (e = n.filter(this.options.more)), e.length ? (this.$more.replaceWith(e), this.$more = e, this.waypoint = new o(this.options)) : this.$more.remove(), this.options.onAfterPageLoad(s) }, this)) }, this) }, t.prototype.destroy = function () { this.waypoint && this.waypoint.destroy() }, t.defaults = { container: "auto", items: ".infinite-item", more: ".infinite-more-link", offset: "bottom-in-view", loadingClass: "infinite-loading", onBeforePageLoad: i.noop, onAfterPageLoad: i.noop }, o.Infinite = t }();

var enableInfiniteScroll = function (parentClass) {
  if ($(parentClass).length) {
    var infiniteScroll = new Waypoint.Infinite({
      element: $(parentClass)[0],
      items: parentClass,
      more: '[data-load-more]',
      loadingClass: 'loading-in-progress',
      onBeforePageLoad: function () {
        $('.js-load-more').hide();
      },
      onAfterPageLoad: function (data) {
        const $gridItems = $(`${parentClass} .grid-product`);

        $(`${parentClass} > ${parentClass} .grid-product`).unwrap(parentClass);

        theme.sections.reinit('collection-grid');
        theme.reinitProductGridItem1();
        document.dispatchEvent(new CustomEvent('collection:reloaded'));
        try {
          var moreHref = document.querySelector('[data-load-more]') &&
            document.querySelector('[data-load-more]').getAttribute('href');
          var nextPage = moreHref && String(moreHref).match(/[?&]page=(\d+)/);
          var pagesLoaded = nextPage ? parseInt(nextPage[1], 10) - 1 : undefined;
          document.dispatchEvent(new CustomEvent('collection:page-loaded', {
            detail: { pagesLoaded: pagesLoaded }
          }));
        } catch (err) { /* ignore */ }

        // Refresh waypoints
        Waypoint.refreshAll();
      }
    })
  }
}

var enableLoadMoreButton = function (parentClass) {

  var $grid = parentClass + '[data-load-more--grid]';
  var $gridItems = parentClass + ' [data-load-more--grid-item]';

  $('body').on('click touchstart', '[data-load-more]', function (e) {
    e.preventDefault();

    var $button = $(this);
    var url = $button.attr('href');

    loadNextPage(url, $button);
  });

  function loadNextPage(url, $button) {

    $.ajax({
      type: 'GET',
      dataType: 'html',
      url: url,
      beforeSend: function () {
        $button.addClass('is-loading');
        $('.load-more__icon').addClass('loading-in-progress').css({
          'height': '40px',
          'width': '40px',
          'opacity': '1'
        });
      },
      success: function success(data) {
        $button.removeClass('is-loading');
        $('.load-more__icon').removeClass('loading-in-progress').css({
          'height': '0',
          'width': '0',
          'opacity': '0'
        });

        const thumbnails = $(data).find($gridItems);
        var loadMoreButtonUrl = $(data).find('[data-load-more]').attr('href');
        $('[data-load-more]').attr('href', loadMoreButtonUrl);
        $($grid).first().append(thumbnails).append($('.js-load-more'));

        theme.reinitProductGridItem1();

        // Re-apply size / in-stock client filter + recount after new cards load
        document.dispatchEvent(new CustomEvent('collection:reloaded'));

        try {
          var fetchedPageMatch = String(url).match(/[?&]page=(\d+)/);
          var fetchedPage = fetchedPageMatch ? parseInt(fetchedPageMatch[1], 10) : 2;
          document.dispatchEvent(new CustomEvent('collection:page-loaded', {
            detail: { pagesLoaded: fetchedPage, url: url }
          }));
        } catch (err) { /* ignore */ }

        // When there are no additional pages, hide load more button
        if (typeof loadMoreButtonUrl == 'undefined') {
          $('[data-load-more]').addClass('is-hidden');
        }
      },
      error: function (x, t, m) {
        console.log(x);
        console.log(t);
        console.log(m);
        location.replace(location.protocol + '//' + location.host + url);
      }
    });
  }
}
$(document).ready(function () {
  let currentStep = sessionStorage.getItem('quizz-step');
  if (currentStep == null || [2, 5, 6].includes(parseInt(currentStep))) {
    sessionStorage.setItem('quizz-step', 0);
  }
  showQuizzStep();
});

function moveToPrevQuizzStep() {
  let currentStep = parseInt(sessionStorage.getItem('quizz-step'));
  do {
    currentStep -= 1;
  } while ([2, 5, 6].includes(currentStep)); // skip removed steps
  sessionStorage.setItem('quizz-step', currentStep);
  showQuizzStep();
}

function moveToNextQuizzStep() {
  let currentStep = parseInt(sessionStorage.getItem('quizz-step'));
  do {
    currentStep += 1;
  } while ([2, 5, 6].includes(currentStep)); // skip removed steps
  sessionStorage.setItem('quizz-step', currentStep);
  showQuizzStep();
}

function showQuizzStep() {
  var currentStep = parseInt(sessionStorage.getItem('quizz-step'));
  $(".quizz-section").each(function (index, element) {
    let $element = $(element);
    if ($element.data('quizz-step') === currentStep) {
      $element.removeClass('display-none');
    } else {
      $element.addClass('display-none');
    }
  });

  if (currentStep === 7) {
    let url = buildQuizUrl();
    console.log("URL", url);
    sessionStorage.setItem('quizz-step', 0);
    $.ajax({
      url: url,
      type: "GET",
      success: function (response) {
        console.log("success");
        var $responseHtml = $(response);
        if ($responseHtml.find(".filtered-product-count").html().trim() == "0 Results") {
          $('#quizz-result > h1').addClass("display-none");
          $('#quizz-result > .default-collection').removeClass("display-none");
          $("#quizz-complete-button").attr('href', `https://ymijeans.com/collections/${sessionStorage.getItem('quizz-default-collection-handle')}`);
        } else {
          $responseHtml.find('.grid.grid--uniform.js-infinite-wrapper').children(':gt(3)').remove();
          let collectionWrapper = $responseHtml.find('.grid__item.grid__item--content');
          collectionWrapper.find('.grid-product__image').attr("alt", "");
          $('#quizz-result').html(collectionWrapper);
        }
      },
      error: function (xhr, status, error) {
        $('#quizz-result').html("<h1>Sorry, Something went wrong.</h1>");
      }
    });
  }
}

function setQuizzSize(event) {
  let $element = $(event.target);
  sessionStorage.setItem('quizz-size', $element.data('quizz-size'));
  $(".quizz-size-container .quizz-dark-button").removeClass('quizz-dark-button');
  $element.addClass('quizz-dark-button');
}

function setQuizzChoice(event, type) {
  let checkedValues = $(event.target).closest('.quizz-step2-radio-container').find('input:checked').map(function () {
    return $(this).val();
  }).get();
  sessionStorage.setItem(type, checkedValues);
}

function encodeWithPlus(str) {
  return encodeURIComponent(str).replace(/%20/g, '+');
}

function capitalizeWords(str) {
  return str.replace(/\b\w/g, c => c.toUpperCase());
}

function encodeWithPlus(str) {
  return encodeURIComponent(str).replace(/%20/g, '+');
}

function capitalizeWords(str) {
  return str.replace(/\b\w/g, c => c.toUpperCase());
}

function encodeWithPlus(str) {
  return encodeURIComponent(str).replace(/%20/g, '+');
}

function buildQuizUrl() {
  let style = sessionStorage.getItem("quizz-fit");      // leg_style
  let raise = sessionStorage.getItem("quizz-raise");    // custom.rise
  let size = sessionStorage.getItem("quizz-size");      // option.size

  // Use a more reliable base URL without the specific section ID
  let url = 'https://ymijeans.com/collections/ymi-all-jeans';

  let filters = [];

  if (size) {
    size = size.split(',').map(item => encodeWithPlus(capitalizeWords(item.trim()))).join(',');
    filters.push("filter.v.option.size=" + size);
  }

  if (raise) {
    // uppercase all letters for raise filter
    raise = raise.split(',').map(item => encodeWithPlus(item.trim().toUpperCase())).join(',');
    filters.push("filter.p.m.custom.rise=" + raise);
  }

  if (style) {
    style = style.split(',').map(item => encodeWithPlus(capitalizeWords(item.trim()))).join(',');
    filters.push("filter.p.m.filter_option.leg_style=" + style);
  }

  if (filters.length > 0) {
    url += "?" + filters.join("&");
  }

  // Store the URL for the button without the section_id parameter
  let buttonUrl = url;

  // For AJAX, we need to specify view or section, but use a more generic approach
  if (url.includes('?')) {
    url += '&view=ajax';
  } else {
    url += '?view=ajax';
  }

  // Fallback URL in case the built URL fails
  let fallbackUrl = "/collections/all";
  if (sessionStorage.getItem('quizz-default-collection-handle')) {
    fallbackUrl = "/collections/" + sessionStorage.getItem('quizz-default-collection-handle');
  }

  // Set the button URL to the non-ajax version
  $("#quizz-complete-button").attr('href', buttonUrl || fallbackUrl);

  // Store a backup of the URL before clearing session storage
  sessionStorage.setItem('quizz-result-url', buttonUrl);

  // Clear session storage after building URL
  sessionStorage.removeItem("quizz-style");
  sessionStorage.removeItem("quizz-fit");
  sessionStorage.removeItem("quizz-raise");
  sessionStorage.removeItem("quizz-length");
  sessionStorage.removeItem("quizz-stretch");
  sessionStorage.removeItem("quizz-size");

  return url;
}

/**
 * Tolstoy inline mode pulls See it on you next to Add to cart and
 * knocks Buy Now out of place. Put the widget back in its app block
 * so the theme editor block position is the position on the page.
 */
(function () {
  function sourceBlock() {
    var nodes = document.querySelectorAll('see-it-on-you, .see-it-on-you');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].closest('.see-it-on-you-inline-wrapper')) continue;
      var block = nodes[i].closest('.shopify-block, .shopify-app-block, [id^="shopify-block-"]');
      if (block) return block;
    }
    return null;
  }

  var stretchCss = [
    ':host { display: block !important; width: 100% !important; max-width: 100% !important; }',
    ':host > div { display: block !important; width: 100% !important; max-width: 100% !important; }',
    'button[aria-haspopup="dialog"] { width: 100% !important; max-width: none !important; box-sizing: border-box !important; align-self: stretch !important; }'
  ].join('');

  function unlockWrapper(wrapper) {
    wrapper.style.setProperty('display', 'block', 'important');
    wrapper.style.setProperty('height', 'auto', 'important');
    wrapper.style.setProperty('max-height', 'none', 'important');
    wrapper.style.setProperty('min-height', '0', 'important');
    wrapper.style.setProperty('width', '100%', 'important');
    wrapper.style.setProperty('max-width', '100%', 'important');
    wrapper.style.setProperty('flex', 'none', 'important');
    stretchSeeItOnYou(wrapper);
  }

  function alignToBuyNow(root) {
    var scope = root.closest('.product-single__meta') || document;
    var buy = scope.querySelector('.js-buy_now_btn');
    if (!buy || buy.offsetWidth === 0) return;
    var width = Math.round(buy.getBoundingClientRect().right - root.getBoundingClientRect().left);
    if (width < 40) return;
    root.style.setProperty('width', width + 'px', 'important');
    root.style.setProperty('max-width', width + 'px', 'important');
  }

  function stretchSeeItOnYou(root) {
    if (!root) return;
    var isSource = root.matches && root.matches('see-it-on-you, .see-it-on-you') && !root.classList.contains('see-it-on-you-inline-wrapper');
    if (isSource && !root.shadowRoot) return;
    root.style.setProperty('display', 'block', 'important');
    root.style.setProperty('width', '100%', 'important');
    root.style.setProperty('max-width', '100%', 'important');
    alignToBuyNow(root);

    var shadow = root.shadowRoot;
    if (!shadow) return;

    var style = shadow.getElementById('ymi-see-it-on-you-stretch');
    if (!style) {
      style = document.createElement('style');
      style.id = 'ymi-see-it-on-you-stretch';
      shadow.appendChild(style);
    }
    if (style.textContent !== stretchCss) style.textContent = stretchCss;

    if (!root.dataset.sioyShadowWatch && window.MutationObserver) {
      root.dataset.sioyShadowWatch = 'true';
      new MutationObserver(function () {
        stretchSeeItOnYou(root);
      }).observe(shadow, { childList: true, subtree: true });
    }
  }

  function restoreAddToCart(group) {
    var parent = group.parentElement;
    if (!parent) return;
    var addBtn = group.querySelector('button[name="add"], .add-to-cart');
    if (addBtn && addBtn.parentElement === group) {
      parent.insertBefore(addBtn, group);
    }
    if (!group.querySelector('.see-it-on-you-inline-wrapper')) {
      group.remove();
    }
  }

  function placeSeeItOnYou() {
    document.querySelectorAll(
      '.see-it-on-you-inline-wrapper, see-it-on-you, .see-it-on-you, [data-tolstoy-rendered="see-it-on-you-v2"]'
    ).forEach(stretchSeeItOnYou);

    var block = sourceBlock();
    var wrappers = document.querySelectorAll('.see-it-on-you-inline-wrapper');
    if (!block || !wrappers.length) return;

    wrappers.forEach(function (wrapper) {
      unlockWrapper(wrapper);
      var group = wrapper.closest('.see-it-on-you-buttons-wrapper');
      if (!block.contains(wrapper)) {
        block.appendChild(wrapper);
      }
      if (group && group.isConnected) restoreAddToCart(group);
    });
  }

  function boot() {
    if (!document.querySelector('.template-product, .product-single__meta')) return;
    placeSeeItOnYou();
    [300, 800, 1600, 3000].forEach(function (delay) {
      window.setTimeout(placeSeeItOnYou, delay);
    });
    window.addEventListener('resize', placeSeeItOnYou);
    if (!window.MutationObserver || !document.body) return;
    var queued = false;
    var observer = new MutationObserver(function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        placeSeeItOnYou();
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

(function () {
  var CATEGORY_TABS = ['JUNIOR', 'JUNIOR PLUS', 'GIRLS', 'TODDLER'];

  function categoryTabLabels(chart) {
    var row = chart.querySelector('.ks-tab-horizontal > .ks-tab-headers');
    if (!row) return [];
    return Array.prototype.map.call(row.querySelectorAll('.ks-tab-header'), function (el) {
      return (el.textContent || '').replace(/\s+/g, ' ').trim().toUpperCase();
    }).filter(Boolean);
  }

  function isRepeatedCategoryChart(chart) {
    var labels = categoryTabLabels(chart);
    if (labels.length !== CATEGORY_TABS.length) return false;
    return CATEGORY_TABS.every(function (name, i) {
      return labels[i] === name;
    });
  }

  function collapseDuplicateKiwiCharts() {
    var containers = document.querySelectorAll('.ks-chart-tab-container, .ks-modal-content');
    Array.prototype.forEach.call(containers, function (container) {
      var charts = Array.prototype.filter.call(container.children, function (el) {
        return el.classList && el.classList.contains('ks-chart-individual');
      });
      var seenCategoryChart = false;
      charts.forEach(function (chart) {
        if (!isRepeatedCategoryChart(chart)) {
          chart.hidden = false;
          return;
        }
        if (seenCategoryChart) {
          chart.hidden = true;
          return;
        }
        seenCategoryChart = true;
        chart.hidden = false;
      });
    });
  }

  function bootKiwiDedupe() {
    collapseDuplicateKiwiCharts(document);
    if (!window.MutationObserver || !document.body) return;
    var queued = false;
    var observer = new MutationObserver(function (mutations) {
      var relevant = mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes, function (node) {
          return node.nodeType === 1 && (
            (node.classList && (
              node.classList.contains('ks-chart-individual') ||
              node.classList.contains('kiwi-sizing-modal-inner') ||
              node.classList.contains('ks-chart-tab-container')
            )) ||
            (node.querySelector && node.querySelector('.ks-chart-individual'))
          );
        });
      });
      if (!relevant || queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        collapseDuplicateKiwiCharts(document);
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootKiwiDedupe);
  } else {
    bootKiwiDedupe();
  }
})();